var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alerts-page" },
    [
      _c("back-button", {
        staticClass: "back-button",
        attrs: { "data-vue-link": "" }
      }),
      _vm._v(" "),
      _c(
        "alerts-container",
        { attrs: { header: "Click & Collect" } },
        [
          _c("alert-list", {
            attrs: {
              slot: "left",
              type: "cc",
              status: "pending",
              alerts: _vm.alerts
            },
            slot: "left"
          }),
          _vm._v(" "),
          _c("alert-list", {
            attrs: {
              slot: "right",
              type: "cc",
              status: "complete",
              alerts: _vm.alerts
            },
            slot: "right"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "alerts-container",
        { attrs: { header: "Pay My Bill" } },
        [
          _c("alert-list", {
            attrs: {
              slot: "left",
              type: "pmb",
              status: "pending",
              alerts: _vm.alerts
            },
            slot: "left"
          }),
          _vm._v(" "),
          _c("alert-list", {
            attrs: {
              slot: "right",
              type: "pmb",
              status: "complete",
              alerts: _vm.alerts
            },
            slot: "right"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "alerts-container",
        { attrs: { header: "Drinks At Table", "data-bottom": "" } },
        [
          _c("alert-list", {
            attrs: {
              slot: "left",
              type: "d",
              status: "pending",
              alerts: _vm.alerts
            },
            slot: "left"
          }),
          _vm._v(" "),
          _c("alert-list", {
            attrs: {
              slot: "right",
              type: "d",
              status: "complete",
              alerts: _vm.alerts
            },
            slot: "right"
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "alerts-container",
        { attrs: { header: "Order Ahead", "data-bottom": "" } },
        [
          _c("alert-list", {
            attrs: {
              slot: "left",
              type: "oa",
              status: "pending",
              alerts: _vm.alerts
            },
            slot: "left"
          }),
          _vm._v(" "),
          _c("alert-list", {
            attrs: {
              slot: "right",
              type: "oa",
              status: "complete",
              alerts: _vm.alerts
            },
            slot: "right"
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78f9c614", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78f9c614","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AlertsPage.vue
// module id = null
// module chunks = 